module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n\t <my-personal-consultar></my-personal-consultar>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/personal/personal.component.html
// module id = ./src/app/personal/personal.component.html
// module chunks = main